const PLACEHOLDER_ORIGIN = 'https://redirect.invalid';

const isBackslashOrControlCharacter = (character: string): boolean =>
  character === '\\' || character <= '\u001F' || character === '\u007F';

const isSameOriginPath = (value: string): boolean =>
  value.startsWith('/') &&
  !value.startsWith('//') &&
  ![...value].some(isBackslashOrControlCharacter) &&
  new URL(value, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;

const decodeOnce = (value: string): string | undefined => {
  try {
    return decodeURIComponent(value);
  } catch {
    return undefined;
  }
};

/**
 * Returns `value` unchanged when it is a same-origin relative path, otherwise `undefined`.
 * Use it before navigating to a user-supplied redirect target.
 */
export const getSafeRedirectPath = (value: string | null | undefined): string | undefined => {
  if (!value || !isSameOriginPath(value)) {
    return undefined;
  }

  const decoded = decodeOnce(value);
  return decoded !== undefined && isSameOriginPath(decoded) ? value : undefined;
};
